/**
 * Perplexity journey — protocol `transact-pilot` (ADR-0159 §3).
 *
 * Discovery LIVE (with a teaching note: PerplexityBot honors robots.txt;
 * Perplexity-User does not — vendor-documented) → honest transact note:
 * PayPal Instant Buy is an enrolled-merchant path on a documented
 * merchant set (grade-B, framed) → discovery-focused terminal phase.
 *
 * No fake mandate / cart / pay phases (per ADR-0159 handoff: transact-
 * pilot journeys do NOT render fake mandate/cart/pay phases). The
 * terminal phase inside `PhaseTimeline` names the pilot rail honestly.
 */

import { buildDiscoveryPhase, buildReadMenuPhase } from './discovery.js';
import type { JourneyContext, Phase } from './types.js';

export function buildPerplexityJourney(ctx: JourneyContext): Phase[] {
  const { agent, live, installed, cardUrl, catalogUrl, liveProducts } = ctx;
  return [
    buildDiscoveryPhase(agent, installed, cardUrl, live.card),
    buildReadMenuPhase(agent, installed, catalogUrl, live.catalog, liveProducts),
    // ── Terminal transact-pilot phase — honest, grade-B framed ──
    {
      id: 'pilot',
      name: 'Transact (pilot)',
      tier: 'illustration',
      narration:
        `Documented by vendor: Perplexity checkout runs on PayPal Instant Buy, an enrolled-merchant pilot. The payment rail is PayPal's — Sill sees the discovery, not the checkout.`,
      endpoint: {
        method: 'POST',
        path: '(vendor pilot rail)',
        status: 200,
        ms: 0,
        body: '{ "rail": "paypal.instant-buy", "enrollment": "vendor-controlled" }',
        live: false,
      },
      ok: true,
    },
  ];
}
